import type { ClipTranscriptSegment } from '../ClipTranscriptSegment';
import type { HasClipTranscriptSegment } from './HasClipTranscriptSegment';
import type { ActiveTranscriptTokenWithClipSegmentAttributes } from '@src/editor/types';

export class RemovedTranscriptClip implements HasClipTranscriptSegment {
  clipTranscriptSegment: ClipTranscriptSegment;

  constructor(props: { clipTranscriptSegment: ClipTranscriptSegment }) {
    this.clipTranscriptSegment = props.clipTranscriptSegment;
  }

  /**
   * Creates a deep clone of this video element
   */
  clone(): RemovedTranscriptClip {
    const el = new RemovedTranscriptClip({
      // TODO: implement clone on ClipTranscriptSegment
      clipTranscriptSegment: this.clipTranscriptSegment, //.clone()
    });

    return el;
  }

  getMediaStartTime(): number {
    return this.clipTranscriptSegment.mediaStart;
  }

  getMediaEndTime(): number {
    return this.clipTranscriptSegment.mediaEnd;
  }

  getClipTranscriptSegment(): ClipTranscriptSegment {
    return this.clipTranscriptSegment;
  }

  getActiveTranscriptText(): string {
    const segment = this.getClipTranscriptSegment();
    if (!segment) {
      return '';
    }
    return segment.getText();
  }

  getActiveTranscriptElements(): ActiveTranscriptTokenWithClipSegmentAttributes[] {
    return this.clipTranscriptSegment
      .getWordsWithPunctuation()
      .map((el, idx) => {
        return {
          ...el,
          state: 'removed',
          // Removed clips are not on timeline; timeline position unknown
          ts: null,
          end_ts: null,
          clip_segment_id: this.clipTranscriptSegment.id,
          clip_segment_position: idx,
        };
      });
  }

  setClipTranscriptSegment(segment: ClipTranscriptSegment): void {
    this.clipTranscriptSegment = segment;
  }
}
